import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import { gray100, gray80, white, gray20, gray40 } from '../../../constants/colors';

interface UsageStatusCardProps {
  processedCount: number;
}

const UsageStatusCard = ({ processedCount }: UsageStatusCardProps): ReactElement => {
  const styles = {
    container: {
      backgroundColor: white,
      borderRadius: '8px',
      padding: '16px',
      border: `1px solid ${gray40}`,
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    title: {
      fontSize: '16px',
      fontWeight: '700',
      color: gray100,
      textAlign: 'left',
    },
    statItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 0',
      borderBottom: `1px solid ${gray20}`,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    statLabel: {
      fontSize: '14px',
      fontWeight: 400,
      color: gray80,
    },
    statValue: {
      fontSize: '20px',
      fontWeight: 700,
      color: gray100,
    },
  };

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>今月の利用状況</Typography>

      <Box sx={styles.statItem}>
        <Typography sx={styles.statLabel}>利用枚数</Typography>
        <Typography sx={styles.statValue}>{processedCount}枚</Typography>
      </Box>

      {/* 次フェーズで実装予定 */}
      {/* <Box sx={styles.statItem}>
        <Typography sx={styles.statLabel}>OCR精度</Typography>
        <Typography sx={styles.statValue}>-%</Typography>
      </Box>

      <Box sx={styles.statItem}>
        <Typography sx={styles.statLabel}>仕分け精度</Typography>
        <Typography sx={styles.statValue}>-%</Typography>
      </Box> */}
    </Box>
  );
};

export default UsageStatusCard;
